import { Deserializable } from '../deserializable';
import {Staffs} from '../staff/staffs';

export  class LogFile implements Deserializable
{
  public id: number;
  public workType: string;
  public className: string;
  public pkID: number;
  public fileId: number;
  public fileName: string;
  public fileKey: string;
  public fileType: string;
  public fileFolder: string;
  public fileWidth: string;
  public createdBy: number;
  public created: Date;
  public staffs: Staffs;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.staffs = input.staffs != null ?  new Staffs().deserialize(input.staffs) : null;
    return this;
  }
}
